<template>
  <div class="income-page">
    <div class="page-header">
      <span class="page-title">彩票经理/代表管理收益记录</span>
      <el-radio-group v-model="role" size="small" @change="onRoleChange">
        <el-radio-button label="represent">彩票代表</el-radio-button>
        <el-radio-button label="manager">彩票经理</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 筛选区 -->
    <div class="filter-bar">
      <el-input v-model="query.userName" :placeholder="role === 'represent' ? '彩票代表用户名' : '彩票经理用户名'"
        prefix-icon="el-icon-user" size="small" clearable style="width: 200px"
        @keyup.enter.native="onSearch" @clear="onSearch" />
      <el-date-picker v-model="dateRange" type="daterange" size="small" style="width: 260px"
        value-format="yyyy-MM-dd" range-separator="至" start-placeholder="认购开始日期" end-placeholder="认购结束日期"
        :picker-options="pickerOptions" @change="onSearch" />
      <el-button type="primary" size="small" icon="el-icon-search" :loading="loading" @click="onSearch">查询</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="onReset">重置</el-button>
    </div>

    <!-- 收益明细表 -->
    <el-table :data="list" border v-loading="loading" empty-text="暂无收益记录"
      :header-cell-style="{ background: '#347caf', color: '#fff', textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }">
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" />
      <el-table-column :label="role === 'represent' ? '彩票代表' : '彩票经理'" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.userName || '-' }}</template>
      </el-table-column>
      <el-table-column v-if="role === 'represent'" label="上级经理" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.managerName || '-' }}</template>
      </el-table-column>
      <el-table-column v-else label="名下代表" min-width="110" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.representName || '-' }}</template>
      </el-table-column>
      <el-table-column label="帮扶投注站" min-width="150" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.shopName || ('投注站' + scope.row.shopId) }}</template>
      </el-table-column>
      <el-table-column label="期号" width="100">
        <template slot-scope="scope">{{ scope.row.number || '-' }}</template>
      </el-table-column>
      <el-table-column label="彩种" width="90">
        <template slot-scope="scope">{{ scope.row.preIndexType || lotteryTypeName(scope.row.preType) }}</template>
      </el-table-column>
      <el-table-column label="认购股数" width="85">
        <template slot-scope="scope">{{ scope.row.purchaserNumber != null ? scope.row.purchaserNumber + ' 股' : '-' }}</template>
      </el-table-column>
      <el-table-column label="应得分红" width="100">
        <template slot-scope="scope">{{ money(scope.row.payable) }}</template>
      </el-table-column>
      <el-table-column label="帮扶资格" width="120">
        <template slot-scope="scope">
          <el-tag v-if="Number(scope.row.ssqEightWinFive) === 1" size="mini" type="success" effect="plain">双色球10中7</el-tag>
          <el-tag v-if="Number(scope.row.dltEightWinFive) === 1" size="mini" type="success" effect="plain">大乐透8中5</el-tag>
          <span v-if="Number(scope.row.ssqEightWinFive) !== 1 && Number(scope.row.dltEightWinFive) !== 1" class="txt-muted">-</span>
        </template>
      </el-table-column>
      <el-table-column label="打款截图" width="100">
        <template slot-scope="scope">
          <el-image v-if="scope.row.remit" :src="scope.row.remit" :preview-src-list="[scope.row.remit]"
            style="width: 60px; height: 45px" fit="cover" />
          <span v-else class="txt-muted">未打款</span>
        </template>
      </el-table-column>
      <el-table-column label="站长/联系方式" min-width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.nickname || scope.row.phone">{{ scope.row.nickname || '-' }}（{{ scope.row.phone || '-' }}）</span>
          <span v-else class="txt-muted">-</span>
        </template>
      </el-table-column>
      <el-table-column label="收益账户余额" width="110">
        <template slot-scope="scope">{{ money(scope.row.balance) }}</template>
      </el-table-column>
      <el-table-column label="认购时间" width="160">
        <template slot-scope="scope">{{ scope.row.createTime || '-' }}</template>
      </el-table-column>
    </el-table>

    <div class="fenye" v-if="total > 0">
      <el-pagination background layout="prev, pager, next" :total="total"
        :page-size="pageSize" :current-page="pageNum" @current-change="onPage" />
    </div>

    <!-- 规则说明 -->
    <div class="rule-card">
      <div class="rule-title">备注</div>
      <div class="rule-content">1、彩票代表双色球10中7以上可以同时帮扶3个投注站，10中6可以同时帮扶2个投注站，10中5只能帮扶1个投注站。</div>
      <div class="rule-content">2、彩票代表大乐透后区10中9以上可以同时帮扶3个投注站，10中8可以同时帮扶2个投注站，10中7只能帮扶1个投注站。</div>
    </div>
  </div>
</template>

<script>
import {
  assistRepresentIncomeList,
  assistManagerIncomeList,
} from "@/api/apply";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "EarningsRecord",
  data() {
    return {
      // represent=彩票代表视角（看上级经理+自己帮扶的投注站），manager=彩票经理视角（看名下代表）
      role: "represent",
      query: { userName: "" },
      dateRange: null,
      pickerOptions: {
        shortcuts: [
          { text: "最近一周", onClick(picker) { const end = new Date(); const start = new Date(); start.setTime(start.getTime() - 3600 * 1000 * 24 * 7); picker.$emit("pick", [start, end]); } },
          { text: "最近一月", onClick(picker) { const end = new Date(); const start = new Date(); start.setMonth(start.getMonth() - 1); picker.$emit("pick", [start, end]); } },
        ],
      },
      list: [],
      loading: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
    };
  },
  mounted() {
    if (this.isLoggedIn()) {
      this.loadList();
    }
  },
  methods: {
    isLoggedIn() {
      return !!(this.$store && this.$store.state && this.$store.state.vuex_token);
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[type] || type || "-";
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    buildParams() {
      const params = {
        userName: this.query.userName || undefined,
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
      };
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0] + " 00:00:00";
        params.endTime = this.dateRange[1] + " 23:59:59";
      }
      return params;
    },
    loadList() {
      this.loading = true;
      const params = this.buildParams();
      const req = this.role === "represent"
        ? assistRepresentIncomeList(params)
        : assistManagerIncomeList(params);
      req
        .then((res) => {
          const rows = (res && res.rows) || (res && res.data && res.data.rows) || [];
          const total = (res && res.total) || (res && res.data && res.data.total) || 0;
          this.list = rows;
          this.total = total;
        })
        .catch(() => {
          this.list = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onRoleChange() {
      this.pageNum = 1;
      this.loadList();
    },
    onSearch() {
      this.pageNum = 1;
      this.loadList();
    },
    onReset() {
      this.query.userName = "";
      this.dateRange = null;
      this.pageNum = 1;
      this.loadList();
    },
    onPage(page) {
      this.pageNum = page;
      this.loadList();
    },
  },
};
</script>

<style lang="scss" scoped>
.income-page {
  background: #ffffff;
  padding: 20px;
  border-radius: 8px;
  min-height: 400px;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  border-bottom: 2px solid #347caf;
  margin-bottom: 16px;

  .page-title {
    font-size: 20px;
    font-weight: bold;
    color: #347caf;
  }
}

.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}

.txt-muted {
  color: #b6c2cc;
}

.fenye {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.rule-card {
  margin-top: 24px;
  padding: 14px 18px;
  background: #f5f9fd;
  border: 1px solid #d6e6f5;
  border-radius: 6px;

  .rule-title {
    font-size: 14px;
    font-weight: bold;
    color: #347caf;
    margin-bottom: 8px;
  }

  .rule-content {
    font-size: 12px;
    color: #7a8b99;
    line-height: 20px;
  }
}
</style>
